import React, {Component} from "react";
import { Link, Navigate } from "react-router-dom";
import withRouter from '../actionHooks/withRouter';
import axiosBaseURL from "../httpCommon";

class OrganizationDetails extends Component {
    constructor(props) {
        super(props);
        this.state={
            organization: "",
            localEvents: [],
            
            loggedIn: window.localStorage.getItem("isLoggedIn"),
            authUser: JSON.parse(window.localStorage.getItem("userData"))
        }
    }

    async componentDidMount() {
          await this.fetchEventDetails();
    }

    async fetchEventDetails(){
        await axiosBaseURL.get('api/v1/organization/' + this.props.params.organization_id, {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.state.authUser.token
            }
        })
            .then(response => {
                if(response.data.status === 200) {
                    this.setState({
                        organization: response.data.organization,
                        localEvents: response.data.localEvents,
                        errMsg: "",
                    })
                }
                if(response.data.status === 404) {
                    this.setState({
                        organization: "",
                        localEvents: [],
                        errMsg: response.data.msg
                    })
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    render (){
        const {loading} = this.state

        const printOrganization = this.state.organization

        const LocalEvents = this.state.localEvents.map((allLocalEvent, key) => {
            return <div key={key}>
                <div className="cart-box px-15">
                    <Link to={"/event/" + allLocalEvent.id} className="cart-img">
                        <img src={allLocalEvent.event_picture} className="img-fluid" alt="" width="60px" height="auto"/>
                    </Link>
                <div className="cart-content">
                    <Link to={"/event/" + allLocalEvent.id}>
                        <h4>{allLocalEvent.title}</h4>
                    </Link>
                    <h5 className="content-color">by 60 Plus Care</h5>                
                </div>
            </div>
            <div className="divider"></div>
        </div>
        });

        return(
            <>
                <header>
                    <div className="back-links">
                        <Link to={"/organizations"}>
                            <i className="iconly-Arrow-Left icli"></i>
                            <div className="content">
                                <h2>Organization Details</h2>
                            </div>
                        </Link>
                    </div>
                </header>
                
                <section className="px-15">
                    <h2 className="page-title">Open Orders</h2>
                    <ul className="order-listing">
                        
                        <li>
                            <div className="order-box">
                                <div className="d-flex align-items-center">
                                    <img src={printOrganization.picture} className="img-fluid order-img" alt=""/>
                                    <div className="media-body">
                                        <h4>{printOrganization.name}</h4>
                                        <h5 className="content-color my-1">{printOrganization.address}</h5>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </section>
                <div className="divider"></div>
                
                <section className="cart-section pt-0 section-b-space">

                    <div className="cart-box px-15 pb-3">
                        <h2>Events under {printOrganization.name}</h2>
                        <hr/>
                    </div>
        
        {this.state.localEvents.length > 0 ?
            LocalEvents
            :
            (<div><p className="">You have No Events Available.</p></div>)
        }
  
    </section>
            </>
        );
    }
}

export default withRouter(OrganizationDetails);